const namespace = 'cart';

export const ADD_TO_CART = `${namespace}/Add`;
export const REMOVE_FROM_CART = `${namespace}/Remove`;
export const EMPTY_CART = `${namespace}/Empty`;
